import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef, useCallback, useState } from 'react';
import ArrowLeftIcon from '@atlaskit/icon/core/migration/arrow-left--arrow-left-circle';
import { N10 } from '@atlaskit/theme/colors';
import ButtonItem from './button-item';
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */
const GoBackItem = /*#__PURE__*/forwardRef(({
  cssFn,
  iconBefore = /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${N10})`,
    label: ""
  }),
  onClick,
  isSelected,
  ...rest
}, ref) => {
  const [isInteracted, setIsInteracted] = useState(false);
  const onClickHandler = useCallback(e => {
    if (isInteracted) {
      return;
    }
    setIsInteracted(true);
    onClick && onClick(e);
  }, [onClick, isInteracted]);
  return /*#__PURE__*/React.createElement(ButtonItem, _extends({
    isSelected: isSelected
    // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
    ,
    cssFn: cssFn,
    iconBefore: iconBefore,
    onClick: onClickHandler,
    ref: ref
  }, rest));
});
export default GoBackItem;